import { Button, Space } from 'antd';
import { debug } from 'zf-web-infra';
import { useMemo, type ReactElement } from 'react';
import { Icons } from '../icons';
import { Block } from '../block';
import styles from './style.module.less';
import type { ImageActionProps } from './types';


export function ImageAction(props: ImageActionProps): ReactElement {
  debug.component('ImageAction', props);
  const stopPropagation = (event: React.MouseEvent<HTMLElement>, cb?: () => void): void => {
    event.preventDefault();
    // 阻止事件冒泡
    event.stopPropagation();
    cb?.();
  };
  const icon = useMemo(() => {
    if (!props.mask) {
      return null;
    }
    if (props.isVideo === true) {
      return <Icons name='PlayCircleOutlined'/>;
    }
    return <Icons name='EyeOutlined' />;
  }, [props.isVideo, props.mask]);
  return (
    <div className={props.mask ? styles.imageMask : styles.actionContainer}>
      <Space wrap>
        <Block if={props.preview !== false}>
          <Button
            type={props.mask ? 'text' : 'default'}
            size={props.mask ? undefined : 'small'}
            className={props.mask ? styles.imageAction : ''}
            icon={icon}
            onClick={event => stopPropagation(event, props.onPreview)}>
            {props.previewName}
          </Button>
        </Block>
        <Block if={props.graffiti === true}>
          <Button
            type={props.mask ? 'text' : 'default'}
            size={props.mask ? undefined : 'small'}
            className={props.mask ? styles.imageAction : ''}
            icon={props.mask ? <Icons name='SignatureOutlined' /> : null}
            onClick={() => props.onGraffiti?.()}>
            {props.graffitiName}
          </Button>
        </Block>
        <Block if={props.edit !== false}>
          <Button
            type={props.mask ? 'text' : 'default'}
            size={props.mask ? undefined : 'small'}
            className={props.mask ? styles.imageAction : ''}
            icon={props.mask ? <Icons name='CloudUploadOutlined' /> : null}
            onClick={() => props.onEdit?.()}>
            {props.editName}
          </Button>
        </Block>
        <Block if={props.remove !== false}>
          <Button
            type={props.mask ? 'text' : 'default'}
            size={props.mask ? undefined : 'small'}
            className={props.mask ? styles.imageAction : ''}
            icon={props.mask ? <Icons name='DeleteOutlined' /> : null}
            onClick={() => props.onRemove?.()}>
            {props.removeName}
          </Button>
        </Block>
      </Space>
    </div>
  );
}
